/**
 * Datos del traslado de la Guía de Remisión (una sola hoja: remitente, destinatario y
 * datos del traslado). Se guardan en la factura (PUT /shipping-guides/{id}/transporte).
 */
export const MOTIVOS = ["Venta", "Traslado entre bodegas", "Consignación", "Devolución", "Otro"];

export const EMPTY_TRANSPORT = { motivo_traslado: "Venta", fecha_inicio_traslado: "", observaciones: "" };

const inputCls = "w-full bg-app border border-border rounded-md px-2.5 py-1.5 text-sm focus:border-agro-green";
const labelCls = "text-[10px] uppercase tracking-wider text-text-secondary mb-1 block font-medium";

export default function TransportForm({ value, onChange, bultos, onBultos }) {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <section>
      <h3 className="font-heading text-xs font-semibold text-agro-green uppercase tracking-wider mb-2">Datos del traslado</h3>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={labelCls}>Motivo del traslado</label>
          <select value={value.motivo_traslado || "Venta"} onChange={set("motivo_traslado")}
            data-testid="guide-motivo_traslado" className={inputCls}>
            {MOTIVOS.map((m) => <option key={m} value={m}>{m}</option>)}
          </select>
        </div>
        <div>
          <label className={labelCls}>Inicio del traslado</label>
          <input type="date" value={value.fecha_inicio_traslado ?? ""} onChange={set("fecha_inicio_traslado")}
            data-testid="guide-fecha_inicio_traslado" className={inputCls} />
        </div>
        <div>
          <label className={labelCls}>Cantidad de bultos</label>
          <input type="number" min={0} value={bultos} onChange={(e) => onBultos(e.target.value)}
            data-testid="guide-bultos" className={inputCls} />
        </div>
        <div className="col-span-2">
          <label className={labelCls}>Observaciones (opcional)</label>
          <input value={value.observaciones ?? ""} onChange={set("observaciones")}
            data-testid="guide-observaciones" className={inputCls} placeholder="Se imprime en la franja de referencia" />
        </div>
      </div>
    </section>
  );
}
